import FooterTemplate from "./FooterTemplate";

export default function Footer() {
  return <FooterTemplate />;
}
